'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _dropdown = require('antd/lib/dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _localeContext = require('../../core/localeContext');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavLink = exports.NavLink = (_dec = (0, _localeContext.localeContext)('NavLink', {
  more: '更多'
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(NavLink, _React$PureComponent);

  function NavLink() {
    _classCallCheck(this, NavLink);

    return _possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).apply(this, arguments));
  }

  _createClass(NavLink, [{
    key: 'setAction',
    value: function setAction(key, flag) {
      var item = void 0;
      if (Object(key) === key) {
        item = key;
      } else {
        item = this.props.links.find(function (item) {
          return item.key === key;
        }) || this.props.menus.find(function (item) {
          return item.key === key;
        });
      }

      if (item.propName) {
        item[item.propName] = flag;
      }

      this.forceUpdate();

      return item;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _this2 = this;

      var key = e.key;

      var item = this.setAction(key, true);
      var action = item.action || this.props.onClick;

      var cancelCallback = function cancelCallback() {
        _this2.setAction(item, false);
      };
      if (action) {
        if (!action(e, this.props.data, cancelCallback)) {
          cancelCallback();
        }
      } else {
        cancelCallback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var handleClick = this.handleClick.bind(this);
      var _props = this.props,
          links = _props.links,
          menus = _props.menus,
          data = _props.data,
          className = _props.className,
          style = _props.style;

      var menu = _react2.default.createElement(
        _menu2.default,
        { onClick: function onClick(e) {
            return handleClick(e);
          }, className: 'j-com-dropdown-link' },
        menus.map(function (item, index) {
          var propsByState = item.getProps ? item.getProps(data) : {};
          return _react2.default.createElement(
            _menu2.default.Item,
            _extends({
              key: item.key || index,
              disabled: item.disabled,
              loading: item.loading
            }, propsByState),
            _react2.default.createElement(
              'a',
              null,
              item.render ? item.render() : item.name
            )
          );
        })
      );
      return _react2.default.createElement(
        'div',
        { className: 'j-com-nav-link ' + className, style: style },
        links.map(function (item, index) {
          var propsByState = item.getProps ? item.getProps(data) : {};
          return _react2.default.createElement(
            _button2.default,
            _extends({
              size: item.size ? item.size : 'small',
              type: item.type ? item.type : 'button',
              className: item.type ? '' : 'ant-btn-link',
              key: item.key || index,
              disabled: item.disabled,
              loading: item.loading,
              onClick: function onClick() {
                return handleClick(item);
              }
            }, propsByState),
            item.href ? _react2.default.createElement(
              'a',
              { href: item.href, target: item.target || '_blank' },
              item.render ? item.render() : item.name
            ) : _react2.default.createElement(
              'span',
              null,
              item.render ? item.render() : item.name
            )
          );
        }),
        menus.length ? this.props.menuLabel ? _react2.default.createElement(
          _dropdown2.default.Button,
          { overlay: menu },
          this.props.menuLabel
        ) : _react2.default.createElement(
          _dropdown2.default,
          { overlay: menu },
          _react2.default.createElement(
            'a',
            { className: 'ant-dropdown-link ant-btn-link' },
            this.getLocale().more,
            _react2.default.createElement(_icon2.default, { type: 'down' })
          )
        ) : null
      );
    }
  }]);

  return NavLink;
}(_react2.default.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,

  links: _propTypes2.default.array,
  menus: _propTypes2.default.array,
  onClick: _propTypes2.default.func,
  data: _propTypes2.default.any,
  menuLabel: _propTypes2.default.any
}, _class2.defaultProps = {
  className: '',
  links: [],
  menus: []
}, _temp)) || _class);


//////////////////
// WEBPACK FOOTER
// ./src/components/navLink/index.jsx
// module id = 12
// module chunks = 0